<!--Vista para crear y editar un evento que no es LITE-->
<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-row justify="center">
          <v-col
            cols="10"
            md="8"
            xl="6"
            class="elevation-1 mb-5 primary white--text text-center"
          >
            <h1 v-if="isNewEvent" class="display-2">
              Registro de nuevo evento
            </h1>
            <h1 v-else class="display-2">Actualización del evento</h1>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="11">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-stepper
                v-model="currentStep"
                vertical
                :non-linear="isNewEvent ? false : true"
              >
                <v-stepper-step
                  :editable="
                    isNewEvent || currentStep == 6
                      ? false
                      : valid
                      ? true
                      : false
                  "
                  :complete="currentStep > 1"
                  step="1"
                  color="accent"
                >
                  Información de contacto
                  <small
                    >¿Cómo pueden los invitados ponerse en contacto con
                    usted?</small
                  >
                </v-stepper-step>

                <v-stepper-content step="1">
                  <v-row justify="center" v-if="currentStep == 1">
                    <v-col cols="12" sm="6" xl="3">
                      <v-text-field
                        v-model="newEvent.name"
                        :rules="eventNameRules"
                        label="Nombre del evento *"
                        hint="Ej: Curso de ventas"
                        required
                        prepend-icon="fas fa-building"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" xl="3">
                      <v-text-field
                        v-model="newEvent.contactDetails.tel"
                        :rules="telRules"
                        label="Teléfono de contacto *"
                        required
                        prepend-icon="fas fa-phone"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" xl="3">
                      <v-text-field
                        v-model="newEvent.contactDetails.email"
                        :rules="emailRules"
                        label="Correo electrónico *"
                        required
                        prepend-icon="fas fa-envelope"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" xl="3">
                      <v-text-field
                        v-model="newEvent.contactDetails.webSite"
                        :rules="webSiteRules"
                        label="Sitio Web"
                        prepend-icon="fas fa-globe"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- :disabled="(!newEvent.name || !newEvent.contactDetails.tel || !newEvent.contactDetails.email || !valid )" -->
                  <v-btn
                    color="accent"
                    class="my-3 mx-1"
                    @click="currentStep++"
                    :disabled="
                      !newEvent.name ||
                      !newEvent.contactDetails.tel ||
                      !newEvent.contactDetails.email ||
                      !valid
                    "
                    >Continuar</v-btn
                  >
                  <v-btn v-if="!isNewEvent"
                    color="secondary"
                    class="mx-1"
                    @click="validateOrganizerStatus('update')"
                    :disabled="
                      !newEvent.name ||
                      !newEvent.contactDetails.tel ||
                      !newEvent.contactDetails.email ||
                      !valid
                    "
                    >Guardar</v-btn
                  >
                </v-stepper-content>

                <v-stepper-step
                  :editable="
                    isNewEvent || currentStep == 6
                      ? false
                      : valid
                      ? true
                      : false
                  "
                  :complete="currentStep > 2"
                  step="2"
                  color="accent"
                >
                  Información del evento
                  <small>Características generales del evento.</small>
                </v-stepper-step>

                <v-stepper-content step="2">
                  <v-row justify="center" v-if="currentStep == 2">
                    <v-col cols="12" sm="6" xl="3">
                      <v-select
                        v-model="newEvent.category"
                        :items="eventCategories"
                        label="Tipo de evento *"
                        prepend-icon="fas fa-filter"
                        required
                        :rules="categoryRules"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" xl="3">
                      <v-select
                        v-model="newEvent.subcategory"
                        :items="categoriesItems"
                        label="Tema *"
                        prepend-icon="fas fa-filter"
                        required
                        :rules="subcategoryRules"
                      >
                        <!-- Template for render selected data -->
                        <template slot="selection" slot-scope="data">
                          <span>{{ data.item.item }}</span>
                        </template>
                        <template slot="item" slot-scope="data">
                          <!-- Divider and Header-->
                          <span
                            @click.stop
                            class="font-weight-bold text-uppercase"
                            v-if="data.item.item.includes('HEADER')"
                          >
                            {{ data.item.item.split("#")[1] }}
                            <hr />
                          </span>
                          <!-- Normal item -->
                          <span v-else>{{ data.item.item }}</span>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      xl="6"
                      v-if="newEvent.subcategory === 'Otro'"
                    >
                      <v-text-field
                        v-model="newEvent.subcategoryText"
                        :rules="anotherSubcategory"
                        label="Epecifique *"
                        prepend-icon="fas fa-filter"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" xl="3">
                      <v-menu
                        v-model="dateMenu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="initialDateFormatted"
                            label="Fecha de inicio *"
                            persistent-hint
                            readonly
                            v-on="on"
                            prepend-icon="fas fa-calendar-day"
                            required
                            :rules="startDateRules"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="newEvent.startDate"
                          no-title
                          @input="dateMenu1 = false"
                          :min="todayDate"
                          locale="es"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" xl="3">
                      <v-menu
                        v-model="dateMenu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="finalDateFormatted"
                            label="Fecha de fin *"
                            persistent-hint
                            readonly
                            v-on="on"
                            prepend-icon="fas fa-calendar-day"
                            required
                            :rules="endDateRules"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="newEvent.endDate"
                          no-title
                          @input="dateMenu2 = false"
                          :min="newEvent.startDate"
                          locale="es"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" xl="3">
                      <v-menu
                        ref="menu1"
                        v-model="timeMenu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="newEvent.startTime"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="newEvent.startTime"
                            label="Hora de inicio *"
                            prepend-icon="fas fa-clock"
                            readonly
                            v-on="on"
                            required
                            :rules="startTimeRules"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="timeMenu1"
                          v-model="newEvent.startTime"
                          full-width
                          @click:minute="$refs.menu1.save(newEvent.startTime)"
                        ></v-time-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" xl="3">
                      <v-menu
                        ref="menu2"
                        v-model="timeMenu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="newEvent.endTime"
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="newEvent.endTime"
                            label="Hora de fin *"
                            prepend-icon="fas fa-clock"
                            readonly
                            v-on="on"
                            required
                            :rules="endTimeRules"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="timeMenu2"
                          v-model="newEvent.endTime"
                          full-width
                          @click:minute="$refs.menu2.save(newEvent.endTime)"
                        ></v-time-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6" xl="3">
                      <v-select
                        v-model="newEvent.modality"
                        :items="modalityCategories"
                        label="Modalidad de evento*"
                        prepend-icon="fas fa-clipboard-list"
                        required
                        @change="modalityChangeActions()"
                        :rules="modalityRules"
                      >
                        <!-- Template for render selected data -->
                        <template slot="selection" slot-scope="data">
                          <span>{{ data.item.item }}</span>
                        </template>
                        <template slot="item" slot-scope="data">
                          <span>{{ data.item.item }}</span>
                        </template>
                      </v-select>
                      <!--
                      <v-row justify="center" class="d-flex">
                        <v-switch
                          class="mr-2"
                          v-model="newEvent.modality"
                          false-value="ON_SITE"
                          true-value="ON_LINE"
                          label="¿Evento en línea?"
                          color="secondary"
                        ></v-switch>
                        <v-tooltip top max-width="350px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" dark v-on="on"
                              >mdi-help-circle</v-icon
                            >
                          </template>
                          <span
                            >Los eventos en línea no requieren que los
                            asistentes acudan a un lugar de forma
                            presencial.</span
                          >
                        </v-tooltip>
                      </v-row>-->
                    </v-col>
                    <v-col cols="12" sm="6" xl="3">
                      <v-row justify="center" class="d-flex">
                        <v-switch
                          class="mr-2"
                          v-model="newEvent.private"
                          label="¿Evento privado?"
                          color="secondary"
                        ></v-switch>
                        <v-tooltip top max-width="350px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" dark v-on="on"
                              >mdi-help-circle</v-icon
                            >
                          </template>
                          <span
                            >Un evento privado no es visible en la sección de
                            eventos y solo se puede acceder a el mediante su
                            URL.</span
                          >
                        </v-tooltip>
                      </v-row>
                    </v-col>
                    <v-col cols="12" v-if="newEvent.modality == 'ON_SITE' || newEvent.modality == 'HYBRID'">
                      <v-row justify="center">
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <div class="v-input theme--light v-text-field">
                            <div class="v-input__prepend-outer">
                              <div class="v-input__icon v-input__icon--prepend">
                                <i
                                  aria-hidden="true"
                                  class="v-icon notranslate fas fa-map-marker-alt theme--light"
                                ></i>
                              </div>
                            </div>
                            <div class="v-input__control d-flex">
                              <div class="v-input__slot">
                                <div class="v-text-field__slot">
                                  <label
                                    for="input-274"
                                    class="v-label theme--light"
                                    style="
                                      left: 0px;
                                      right: auto;
                                      position: absolute;
                                    "
                                  ></label>
                                  <gmap-autocomplete
                                    placeholder="Ubicación del recinto *"
                                    required
                                    @place_changed="saveAddress"
                                    :value="place"
                                  ></gmap-autocomplete>
                                </div>
                              </div>
                            </div>
                            <v-tooltip top max-width="350px">
                              <template v-slot:activator="{ on }">
                                <v-icon color="primary" dark v-on="on"
                                  >mdi-help-circle</v-icon
                                >
                              </template>
                              <span
                                >Para llenar este campo correctamente es necesario
                                seleccionar alguna de las opciones que se sugieren
                                al momento de estar escribiendo la ubicación.</span
                              >
                            </v-tooltip>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                    
                    <v-col
                      class="py-1 d-flex"
                      cols="12"
                      md="6"
                      v-if="newEvent.modality == 'ON_LINE' || newEvent.modality == 'HYBRID'"
                    >
                      <v-text-field
                        v-model="newEvent.onlineEventUrl"
                        label="Liga de acceso para evento en línea"
                        prepend-icon="fas fa-globe"
                      ></v-text-field>
                      <v-tooltip top max-width="350px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on"
                            >mdi-help-circle</v-icon
                          >
                        </template>
                        <span
                          >Esta liga les llegará a los asistentes cuando
                          finalicen el proceso de registro. Unos ejemplos son
                          las ligas de acceso que son proporcionadas por Zoom,
                          Hangouts o Teams (Si no aplica para tu evento, este
                          campo puede quedar vacío).</span
                        >
                      </v-tooltip>
                    </v-col>
                    <v-col
                      class="py-1 d-flex"
                      cols="12"
                      sm="6"
                      xl="3"
                      v-if="newEvent.modality == 'ON_LINE' || newEvent.modality == 'HYBRID'"
                    >
                      <v-text-field
                        v-model="newEvent.meetingId"
                        label="Id meeting"
                        prepend-icon="fas fa-id-card"
                      ></v-text-field>
                      <v-tooltip top max-width="350px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on"
                            >mdi-help-circle</v-icon
                          >
                        </template>
                        <span
                          >Este Id les llegará a los asistentes cuando finalicen
                          el proceso de registro. Algunas veces este id es
                          proporcionado por plataformas como Zoom (Si no aplica
                          para tu evento, este campo puede quedar vacío).</span
                        >
                      </v-tooltip>
                    </v-col>
                    <v-col
                      class="py-1 d-flex"
                      cols="12"
                      sm="6"
                      xl="3"
                      v-if="newEvent.modality == 'ON_LINE' || newEvent.modality == 'HYBRID'"
                    >
                      <v-text-field
                        v-model="newEvent.meetingPass"
                        label="Contraseña"
                        prepend-icon="fas fa-key"
                      ></v-text-field>
                      <v-tooltip top max-width="350px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on"
                            >mdi-help-circle</v-icon
                          >
                        </template>
                        <span
                          >Esta contraseña les llegará a los asistentes cuando
                          finalicen el proceso de registro. Algunas veces esta
                          contraseña es proporcionada por plataformas como Zoom
                          (Si no aplica para tu evento, este campo puede quedar
                          vacío).</span
                        >
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <!-- :disabled="(!newEvent.category || !newEvent.subcategory || !newEvent.startDate || !newEvent.endDate || !newEvent.startTime || !newEvent.endTime || !valid )" -->
                  <v-btn
                    color="accent"
                    class="my-3 mx-1"
                    @click="validateLocation()"
                    :disabled="
                      !newEvent.category ||
                      !newEvent.subcategory ||
                      !newEvent.startDate ||
                      !newEvent.endDate ||
                      !newEvent.startTime ||
                      !newEvent.endTime ||
                      !valid ||
                      (newEvent.subcategory === 'Otro' &&
                        !newEvent.subcategoryText) ||
                      (newEvent.modality == 'ON_SITE' && place == null) ||
                      (newEvent.modality == 'HYBRID' && place == null)
                    "
                    >Continuar</v-btn
                  >
                  <v-btn v-if="!isNewEvent"
                    color="secondary"
                    class="mx-1"
                    @click="validateOrganizerStatus('update')"
                    :disabled="
                      !newEvent.category ||
                      !newEvent.subcategory ||
                      !newEvent.startDate ||
                      !newEvent.endDate ||
                      !newEvent.startTime ||
                      !newEvent.endTime ||
                      !valid ||
                      (newEvent.subcategory === 'Otro' &&
                        !newEvent.subcategoryText) ||
                      (newEvent.modality == 'ON_SITE' && place == null) ||
                      (newEvent.modality == 'HYBRID' && place == null)
                    "
                    >Guardar</v-btn
                  >
                  <v-btn text class="mx-1" @click="currentStep--">Regresar</v-btn>
                </v-stepper-content>

                <v-stepper-step
                  :editable="
                    isNewEvent || currentStep == 6
                      ? false
                      : valid
                      ? true
                      : false
                  "
                  :complete="currentStep > 3"
                  step="3"
                  color="accent"
                >
                  Amenidades
                  <small>Carácterísticas adicionales del evento.</small>
                </v-stepper-step>

                <v-stepper-content step="3">
                  <v-row justify="center" v-if="currentStep == 3">
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      xl="3"
                      v-for="(amenity, index) in amenities"
                      :key="index"
                    >
                      <v-row
                        justify="center"
                        v-if="
                          newEvent.modality == 'ON_SITE' ||
                          amenity == 'Constancia'
                        "
                      >
                        <v-switch
                          color="secondary"
                          v-model="newEvent.amenities"
                          :value="amenity"
                          :label="amenity"
                        ></v-switch>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-btn color="accent" class="my-3 mx-1" @click="currentStep++"
                    >Continuar</v-btn
                  >
                  <v-btn v-if="!isNewEvent"
                    color="secondary"
                    class="mx-1"
                    @click="validateOrganizerStatus('update')"
                    >Guardar</v-btn
                  >
                  <v-btn text class="mx-1" @click="currentStep--">Regresar</v-btn>
                </v-stepper-content>

                <v-stepper-step
                  :editable="
                    isNewEvent || currentStep == 6
                      ? false
                      : valid
                      ? true
                      : false
                  "
                  :complete="currentStep > 4"
                  step="4"
                  color="accent"
                >
                  Boletos
                  <small>¿Qué categorías de boletos habrá en el evento?</small>
                </v-stepper-step>

                <v-stepper-content step="4">
                  <v-row justify="center" class="text-center">
                    <v-col cols="12" sm="6" lg="4" class="pb-0">
                      <p class="mb-0">
                        ¿El evento es gratuito?
                        <v-tooltip top max-width="350px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" dark v-on="on"
                              >mdi-help-circle</v-icon
                            >
                          </template>
                          <span
                            >Activa esta opción si tu evento es gratuito.</span
                          >
                        </v-tooltip>
                      </p>
                      <v-row justify="center">
                        <v-switch
                          color="secondary"
                          v-model="newEvent.freeEvent"
                          @change="
                            newEvent.freeEvent
                              ? (newEvent.installments = false)
                              : ''
                          "
                        ></v-switch>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      lg="4"
                      class="pb-0"
                      v-if="!newEvent.freeEvent"
                    >
                      <p class="mb-0">¿Se aceptan meses sin intereses?</p>
                      <v-row justify="center">
                        <v-switch
                          color="secondary"
                          v-model="newEvent.installments"
                        ></v-switch>
                      </v-row>
                      <p v-if="newEvent.installments" class="body-2">
                        Aplica sobretasa al ofrecer MSI
                        <small>
                          <a
                            href="https://www.openpay.mx/costos.html"
                            target="_blank"
                            >Más información</a
                          >
                        </small>
                      </p>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      lg="4"
                      class="pb-0"
                      v-if="!newEvent.freeEvent"
                    >
                      <p class="mb-0">
                        ¿Ofrecerás la opción de facturar?
                        <v-tooltip top max-width="350px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" dark v-on="on"
                              >mdi-help-circle</v-icon
                            >
                          </template>
                          <span
                            >Al activar esta función, habilitas los campos para
                            que las personas que requieran factura puedan dejar
                            sus datos, mismos que podrás consultar desde tu
                            tablero. Recuerda que quien factura eres tú como
                            organizador del evento.</span
                          >
                        </v-tooltip>
                      </p>
                      <v-row justify="center">
                        <v-switch
                          color="secondary"
                          v-model="newEvent.offerBilling"
                        ></v-switch>
                      </v-row>
                    </v-col>
                    <!--<v-col cols="12" class="pb-0" v-if="!newEvent.freeEvent">
                      <p class="mb-0">¿Deseas trasladar la comisión de la pasarela de pago al asistente?
                        <v-tooltip top max-width="350px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" dark v-on="on">mdi-help-circle</v-icon>
                          </template>
                          <span>Al activar esta opción se le aumentará la comisión de la pasarela de pago al total de la orden del asistente. Cada opción de pago tiene diferentes comisiones.</span>
                        </v-tooltip>
                      </p>
                      <v-row justify="center">
                        <v-switch
                          color="secondary"
                          v-model="newEvent.totalBreakdown"
                        ></v-switch>
                      </v-row>
                    </v-col>-->
                  </v-row>
                  <v-row class="mb-5" v-if="currentStep == 4">
                    <v-col cols="12" class="pb-0">
                      <h2 class="title">Boletos</h2>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      lg="4"
                      xl="3"
                      class="pt-0"
                      v-for="(ticket, index) in newEvent.tickets"
                      :key="`ticket${index}`"
                    >
                      <v-row justify="center">
                        <v-col cols="12" class="py-1">
                          <v-text-field
                            :rules="ticketNameRules"
                            label="Nombre del boleto *"
                            hint="Ej: General"
                            required
                            prepend-icon="fas fa-ticket-alt"
                            v-model="newEvent.tickets[index].name"
                          ></v-text-field>
                        </v-col>
                        <v-col v-if="newEvent.modality == 'HYBRID'" cols="12" class="py-1 d-flex">
                          <v-select
                            v-model="newEvent.tickets[index].accessType"
                            :items="modalityCategories"
                            label="Tipo de boleto"
                            prepend-icon="fas fa-filter"
                            required
                            :rules="ticketTypeRules"
                          >
                            <!-- Template for render selected data -->
                            <template slot="selection" slot-scope="data">
                              <span>{{ data.item.item }}</span>
                            </template>
                            <template slot="item" slot-scope="data">
                              <span>{{ data.item.item }}</span>
                            </template>
                          </v-select>
                          <v-tooltip top max-width="300px">
                            <template v-slot:activator="{ on }">
                              <v-icon color="primary" dark v-on="on"
                                >mdi-help-circle</v-icon
                              >
                            </template>
                            <p class="ma-0">El tipo de boleto sirve para saber lo que recibirán tus asistentes al finalizar su registro.</p>
                            <p class="ma-0">En sitio (Código QR).</p>
                            <p class="ma-0">En línea (Liga de acceso ingresada en el paso 2)</p>
                            <p class="ma-0">Híbrido (Código QR y liga de acceso).</p>
                          </v-tooltip>
                        </v-col>
                        <v-col
                          cols="12"
                          class="py-1 d-flex"
                          v-if="!newEvent.freeEvent"
                        >
                          <v-text-field
                            class="mr-2"
                            label="Precio del boleto *"
                            type="number"
                            :rules="ticketPriceRules"
                            min="10"
                            prepend-icon="fas fa-dollar-sign"
                            v-model.number="newEvent.tickets[index].price"
                          ></v-text-field>
                          <!--<v-tooltip top max-width="300px" v-model="invalidTicketPrice">-->
                          <v-tooltip top max-width="300px">
                            <template v-slot:activator="{ on }">
                              <v-icon color="primary" dark v-on="on"
                                >mdi-help-circle</v-icon
                              >
                            </template>
                            <span
                              >Si tu evento es gratuito selecciona la opción que
                              se encuentra en la parte superior de los boletos.
                              Si tu evento es con costo el precio del boleto
                              debe ser mayor a $10 pesos.</span
                            >
                          </v-tooltip>
                        </v-col>
                        <v-col cols="12" class="py-1 d-flex">
                          <v-text-field
                            :disabled="
                              newEvent.tickets[index].inventory.inventoryType ==
                              'INFINITE'
                            "
                            label="Cantidad de boletos disponibles*"
                            :rules="ticketQtyRules"
                            prepend-icon="fas fa-hashtag"
                            type="number"
                            min="1"
                            v-model.number="
                              newEvent.tickets[index].inventory.quantity
                            "
                          ></v-text-field>
                          <v-tooltip top max-width="350px">
                            <template v-slot:activator="{ on }">
                              <v-icon color="primary" dark v-on="on"
                                >mdi-help-circle</v-icon
                              >
                            </template>
                            <span
                              >Cantidad de registros que pueden ser realizados
                              con este boleto (Si no hay límite de registros
                              activa la opcion de "Sin límite").</span
                            >
                          </v-tooltip>
                        </v-col>
                        <v-col cols="6" class="py-1">
                          <v-row justify="center">
                            <v-checkbox
                              false-value="FINITE"
                              true-value="INFINITE"
                              v-model="
                                newEvent.tickets[index].inventory.inventoryType
                              "
                              @change="infiniteTickets(index)"
                              label="Sin límite"
                            ></v-checkbox>
                          </v-row>
                        </v-col>
                        <v-col cols="6" class="py-1">
                          <v-row justify="center">
                            <v-checkbox
                              false-value="INACTIVE"
                              true-value="ACTIVE"
                              v-model="newEvent.tickets[index].estatus"
                              label="Activo"
                            ></v-checkbox>
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row justify="center">
                        <v-btn
                          v-if="
                            (newEvent.tickets.length > 1 && isNewEvent) ||
                            (!isNewEvent && index >= originalTicketsQty)
                          "
                          color="secondary"
                          @click="
                            newEvent.tickets.length > 1
                              ? deleteTicket(ticket.name)
                              : ''
                          "
                          class="mx-2"
                        >
                          <v-icon x-small>fas fa-minus</v-icon>
                        </v-btn>
                        <v-btn
                          v-if="index == newEvent.tickets.length - 1"
                          color="primary"
                          @click="addTicket()"
                        >
                          <v-icon x-small>fas fa-plus</v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <h2 class="title">
                        ¿Cuántos accesos se pueden adquirir por cada registro?
                      </h2>
                    </v-col>
                    <v-col cols="12" sm="5" class="pt-0">
                      <!--<v-text-field
                        type="number"
                        label="Cantidad de accesos por transacción"
                        required
                        prepend-icon="fas fa-hashtag"
                        v-model.number="newEvent.productsPerOrder"
                      ></v-text-field>-->
                      <v-select
                        class="pt-0"
                        :items="[1, 2, 3, 4, 5]"
                        required
                        v-model.number="newEvent.productsPerOrder"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <!-- Código comentado hasta que se analice que tipo de mensaje quiere colocar el organizador y evitar correos spam -->
                  <!-- <v-row>
                  <v-col cols="12" class="pb-0">
                      <h2 class="title">
                        Mensaje
                      <v-tooltip top max-width="300px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on"
                            >mdi-help-circle</v-icon
                          >
                        </template>
                        <span
                          >Escribe un mensaje a los asistentes para que aparezca en su boleto.</span
                        >
                      </v-tooltip>
                      </h2>
                  </v-col>                   
                    <v-col cols="12">
                      <tiptap-vuetify
                        v-model="newEvent.message"
                        :extensions="extensions"
                      />
                      <small>Evita palabras o frases promocionales que puedan clasificarse como correos de spam. Ejemplo: "Compra ahora mismo",""</small>
                    </v-col>
                  </v-row> -->
                  <v-btn color="accent" class="my-3 mx-1" @click="validateTickets()"
                    :disabled="!valid"
                    >Continuar</v-btn
                  >
                  <v-btn v-if="!isNewEvent"
                    color="secondary"
                    class="mx-1"
                    :disabled="!valid"
                    @click="validateOrganizerStatus('update')"
                    >Guardar</v-btn
                  >
                  <v-btn text class="mx-1" @click="currentStep--">Regresar</v-btn>
                </v-stepper-content>

                <v-stepper-step
                  :editable="
                    isNewEvent || newEvent.freeEvent || currentStep == 6
                      ? false
                      : valid
                      ? true
                      : false
                  "
                  :complete="currentStep > 5"
                  step="5"
                  color="accent"
                >
                  Cortesías y cupones (eventos con costo)
                  <small
                    >¿Quisieras agregar cortesías y cupones de descuento al
                    evento?</small
                  >
                </v-stepper-step>

                <v-stepper-content step="5">
                  <v-row align="center">
                    <v-col cols="12">
                      <h2 class="title text-center">
                        Si lo deseas puedes agregar cortesías y cupones de
                        descuento al evento. Para los cupones simplemente asigna
                        un nombre al cupón y un porcentaje de descuento. Para
                        las cortesías pones el número de cortesías que deseas
                        (con un máximo de 5000) y se generan automaticamente,
                        posteriormente puedes descargar la lista de cortesías en
                        "Mi tablero".
                      </h2>
                      <h2 class="title text-center">
                        Cualquier persona que conozca el nombre de la cortesía o
                        cupón podrá utilizarlo al momento de adquirir boletos.
                      </h2>
                      <v-row justify="center">
                        <v-switch
                          color="secondary"
                          v-model="newEvent.haveCoupons"
                          @change="wantCoupons()"
                          class="ml-3 ml-sm-0"
                          label="Deseo agregar cortesías y/o cupones."
                        ></v-switch>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row v-if="newEvent.haveCoupons" class="px-3">
                    <v-col cols="12" class="pb-0 d-flex">
                      <h2 class="title">
                        Ingrese la cantidad de cortesías a generar
                      </h2>
                      <v-tooltip top max-width="350px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on"
                            >mdi-help-circle</v-icon
                          >
                        </template>
                        <span
                          >Ingresa una cantidad de 5000 o menos, para que se
                          generen las cortesías al momento de guardar el evento
                          y la cantidad de 0 para no generar cortesías o
                          quitarlas</span
                        >
                      </v-tooltip>
                    </v-col>
                    <v-col cols="12" sm="5" class="pt-0">
                      <v-text-field
                        type="number"
                        label="Cantidad de cortesías del evento"
                        required
                        :rules="courtesyQtyRules"
                        prepend-icon="fas fa-hashtag"
                        v-model.number="newEvent.quantityOfCourtesies"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="newEvent.haveCoupons" class="px-3">
                    <v-col cols="11" class="pb-0">
                      <h2 class="title">Cupones</h2>
                    </v-col>
                    <v-col
                      cols="11"
                      sm="6"
                      lg="4"
                      xl="3"
                      class="pt-0"
                      v-for="(coupon, index) in newEvent.coupons"
                      :key="`coupon${index}`"
                    >
                      <v-text-field
                        label="Nombre del cupón *"
                        hint="Ej: Desc10"
                        prepend-icon="fas fa-tags"
                        v-model="newEvent.coupons[index].name"
                      ></v-text-field>
                      <v-text-field
                        :rules="couponDiscountRules"
                        label="Porcentaje de descuento *"
                        type="number"
                        min="0"
                        max="100"
                        prepend-icon="fas fa-percent"
                        v-model.number="newEvent.coupons[index].percentOff"
                      ></v-text-field>
                      <!--Cantidad de cupones disponibles (POR DESARROLLAR)-->
                      <!--
                      <v-text-field
                        :rules="couponQtyRules"
                        label="Cantidad"
                        type="number"
                        prepend-icon="fas fa-hashtag"
                        v-model="newEvent.coupons[index].maxRedemptions"
                      ></v-text-field>-->
                      <v-row justify="center">
                        <v-btn
                          v-if="
                            (newEvent.coupons.length > 1 && isNewEvent) ||
                            (!isNewEvent && index >= originalCouponsQty)
                          "
                          color="secondary"
                          @click="
                            newEvent.coupons.length > 1
                              ? deleteCoupon(coupon.name)
                              : ''
                          "
                          class="mx-2"
                        >
                          <v-icon x-small>fas fa-minus</v-icon>
                        </v-btn>
                        <v-btn
                          v-if="index == newEvent.coupons.length - 1"
                          color="primary"
                          @click="addCoupon()"
                        >
                          <v-icon x-small>fas fa-plus</v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-btn
                    color="accent"
                    class="my-3 mx-1"
                    :disabled="!valid"
                    @click="checkCoupons()"
                    >Continuar</v-btn
                  >
                  <v-btn v-if="!isNewEvent"
                    color="secondary"
                    class="mx-1"
                    @click="validateOrganizerStatus('update')"
                    :disabled="!valid"
                    >Guardar</v-btn
                  >
                  <v-btn text class="mx-1" @click="currentStep--">Regresar</v-btn>
                </v-stepper-content>

                <v-stepper-step
                  :editable="isNewEvent ? false : valid ? true : false"
                  :complete="currentStep > 6"
                  step="6"
                  color="accent"
                  >Detalles del evento</v-stepper-step
                >
                <v-stepper-content step="6">
                  <v-row v-if="currentStep == 6">
                    <v-col cols="12" xl="8">
                      <v-combobox
                        v-model="newEvent.tags"
                        :items="exampleTags"
                        :search-input.sync="search"
                        hide-selected
                        hint="Ej. Ventas, Control."
                        label="Tags del evento"
                        multiple
                        persistent-hint
                        small-chips
                        prepend-icon="fas fa-key"
                      >
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>
                                No hay resultados para "
                                <strong>{{ search }}</strong
                                >". Presiona <kbd>enter</kbd> para crear un
                                nuevo tag.
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" sm="6" xl="4">
                      <v-text-field
                        v-model="newEvent.socialMedia.facebook"
                        :rules="socialMediaRules"
                        label="Perfil de Facebook"
                        hint="Facebook URL"
                        prepend-icon="fab fa-facebook-square"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" xl="4">
                      <v-text-field
                        v-model="newEvent.socialMedia.twitter"
                        :rules="socialMediaRules"
                        label="Perfil de Twitter"
                        hint="Twitter URL"
                        prepend-icon="fab fa-twitter-square"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" xl="4">
                      <v-text-field
                        v-model="newEvent.socialMedia.linkedin"
                        :rules="socialMediaRules"
                        label="Perfil de LinkedIn"
                        hint="LinkedIn URL"
                        prepend-icon="fab fa-linkedin"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" xl="4">
                      <v-text-field
                        v-model="newEvent.socialMedia.instagram"
                        :rules="socialMediaRules"
                        label="Perfil de Instagram"
                        hint="Instagram URL"
                        prepend-icon="fab fa-instagram"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" xl="4" class="d-flex">
                      <v-text-field
                        class="mr-2"
                        v-model="newEvent.socialMedia.youtube"
                        :rules="socialMediaRules"
                        label="Video promocional"
                        hint="Youtube URL"
                        prepend-icon="fab fa-youtube"
                      ></v-text-field>
                      <v-tooltip top max-width="350px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="primary" dark v-on="on"
                            >mdi-help-circle</v-icon
                          >
                        </template>
                        <span>Ingresa la URL de un video de youtube.</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-row v-if="currentStep == 6">
                    <v-col cols="12">
                      <h2 class="title">Preguntas frecuentes</h2>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      xl="4"
                      class="pt-0"
                      v-for="(item, index) in newEvent.faqs"
                      :key="`question${index}`"
                    >
                      <v-text-field
                        :ref="item.question"
                        label="Pregunta"
                        prepend-icon="fas fa-question-circle"
                        v-model="newEvent.faqs[index].question"
                      ></v-text-field>
                      <v-textarea
                        :ref="item.answer"
                        label="Respuesta"
                        prepend-icon="fas fa-check-circle"
                        v-model="newEvent.faqs[index].answer"
                      ></v-textarea>
                      <v-row justify="center">
                        <v-btn
                          v-if="newEvent.faqs.length > 1"
                          color="secondary"
                          @click="
                            newEvent.faqs.length > 1
                              ? deleteQuestion(item.question)
                              : ''
                          "
                          class="mx-2"
                        >
                          <v-icon x-small>fas fa-minus</v-icon>
                        </v-btn>
                        <v-btn
                          v-if="index == newEvent.faqs.length - 1"
                          color="primary"
                          @click="addQuestion()"
                        >
                          <v-icon x-small>fas fa-plus</v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row class="mb-5">
                    <v-col cols="12">
                      <h2 class="title">
                        Flyer del evento. Medida recomedada (Mayor a 800px)
                        <v-tooltip top max-width="350px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" dark v-on="on"
                              >mdi-help-circle</v-icon
                            >
                          </template>
                          <span
                            >La tarjeta de tu evento será ilustrada con esta
                            imagen en la sección de Eventos de WeChamber.</span
                          >
                        </v-tooltip>
                      </h2>
                      <p class="body-2 pt-3" v-if="!this.isNewEvent">
                        <strong
                          >Si ya subiste un flyer y deseas reemplazarlo, solo
                          tienes que subir otro nuevo </strong
                        ><i
                          class="fas fa-exclamation-triangle accent--text"
                        ></i>
                      </p>
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="newEvent.eventFlyer && newEvent.eventFlyer != ''"
                    >
                      <p class="text-center">Imagen actual</p>
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="newEvent.eventFlyer && newEvent.eventFlyer != ''"
                    >
                      <v-img
                        :src="newEvent.eventFlyer"
                        max-width="350px"
                        class="mx-auto"
                        lazy-src="https://picsum.photos/id/11/10/6"
                      ></v-img>
                    </v-col>
                    <v-col cols="12">
                      <file-pond
                        name="event-flyer"
                        ref="pondFlyer"
                        label-idle="Agrega un flyer del evento aquí... (.JPG o .PNG)"
                        accepted-file-types="image/jpeg, image/png"
                      />
                    </v-col>
                    <v-col cols="12">
                      <h2 class="title">
                        Encabezado del evento (1920px Ancho x 700px Alto)
                        <v-tooltip top max-width="350px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" dark v-on="on"
                              >mdi-help-circle</v-icon
                            >
                          </template>
                          <span
                            >Esta imagen aparecerá en la parte superior de la
                            descripción del evento.</span
                          >
                        </v-tooltip>
                      </h2>
                      <p class="body-2 pt-3" v-if="!this.isNewEvent">
                        <strong
                          >Si ya subiste un encabezado y deseas reemplazarlo,
                          solo tienes que subir otro nuevo </strong
                        ><i
                          class="fas fa-exclamation-triangle accent--text"
                        ></i>
                      </p>
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="newEvent.eventImage && newEvent.eventImage != ''"
                    >
                      <p class="text-center">Imagen actual</p>
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="newEvent.eventImage && newEvent.eventImage != ''"
                    >
                      <v-img
                        :src="newEvent.eventImage"
                        max-width="350px"
                        class="mx-auto"
                        lazy-src="https://picsum.photos/id/11/10/6"
                      ></v-img>
                    </v-col>
                    <v-col cols="12">
                      <file-pond
                        name="event-img"
                        ref="pondHeader"
                        label-idle="Agrega la imagen del encabezado de evento aquí... (.JPG o .PNG)"
                        accepted-file-types="image/jpeg, image/png"
                      />
                    </v-col>
                    <v-col cols="12">
                      <h2 class="title">
                        Patrocinadores del evento (300px Ancho x 300px Alto)
                        <v-tooltip top max-width="350px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" dark v-on="on"
                              >mdi-help-circle</v-icon
                            >
                          </template>
                          <span
                            >Estas imágenes aparecerán en la parte inferior de
                            la descripción del evento.</span
                          >
                        </v-tooltip>
                      </h2>
                      <p class="body-2 pt-3" v-if="!this.isNewEvent">
                        <strong
                          >Si ya subiste las imágenes de los patrocinadores y
                          deseas reemplazarlas, solo tienes que subir nuevamente
                          las imagenes de los patrocinadores que deseas que
                          aparezcan </strong
                        ><i
                          class="fas fa-exclamation-triangle accent--text"
                        ></i>
                      </p>
                    </v-col>
                    <v-col cols="12" v-if="newEvent.sponsors.length > 0">
                      <p class="text-center">Patrocinadores actuales</p>
                    </v-col>
                    <v-col cols="12" v-if="newEvent.sponsors.length > 0">
                      <v-row
                        justify="center"
                        class="grey lighten-2 text-center py-10 mx-0"
                      >
                        <v-col
                          cols="4"
                          md="3"
                          lg="2"
                          v-for="(sponsor, index) in newEvent.sponsors"
                          :key="index"
                        >
                          <v-row
                            justify="center"
                            align="center"
                            class="fill-height"
                          >
                            <img
                              :src="sponsor"
                              class="sponsor-img"
                              width="80px"
                            />
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <file-pond
                        name="event-sponsors"
                        ref="pondSponsors"
                        label-idle="Agrega los logos de los patrocinadres del evento aquí... (.PNG)"
                        allow-multiple="true"
                        max-files="12"
                        accepted-file-types="image/png"
                        allowImagePreview="false"
                      />
                    </v-col>
                  </v-row>
                  <v-btn
                    color="accent"
                    class="my-3 mx-1"
                    :disabled="!valid"
                    @click="processFile(), currentStep++"
                    >Continuar</v-btn
                  >
                  <v-btn v-if="!isNewEvent"
                    color="secondary"
                    class="mx-1"
                    @click="validateOrganizerStatus('update')"
                    :disabled="!valid"
                    >Guardar</v-btn
                  >
                  <v-btn
                    text
                    class="mx-1"
                    @click="
                      newEvent.freeEvent
                        ? (currentStep = currentStep - 2)
                        : currentStep--
                    "
                    >Regresar</v-btn
                  >
                </v-stepper-content>

                <v-stepper-step
                  :editable="
                    isNewEvent || currentStep == 6
                      ? false
                      : valid
                      ? true
                      : false
                  "
                  :complete="currentStep > 7"
                  step="7"
                  color="accent"
                >
                  Editor del contenido del evento
                  <small>¡Agrega todo el contenido para el evento!</small>
                </v-stepper-step>
                <v-stepper-content step="7">
                  <v-row v-if="currentStep == 7">
                    <v-col cols="12">
                      <tiptap-vuetify
                        v-model="newEvent.details"
                        :extensions="extensions"
                      />
                    </v-col>
                  </v-row>
                  <v-btn
                    color="accent"
                    class="my-3 mx-1"
                    :disabled="!valid"
                    @click="currentStep++"
                    >Continuar</v-btn
                  >
                  <v-btn v-if="!isNewEvent"
                    color="secondary"
                    class="mx-1"
                    @click="validateOrganizerStatus('update')"
                    :disabled="!valid"
                    >Guardar</v-btn
                  >
                  <v-btn text class="mx-1" @click="currentStep--">Regresar</v-btn>
                </v-stepper-content>

                <v-stepper-step
                  :editable="
                    isNewEvent || currentStep == 6
                      ? false
                      : valid
                      ? true
                      : false
                  "
                  step="8"
                  color="accent"
                >
                  Información adicional de los asistentes
                  <small
                    >Agrega campos personalizados para obtener información que
                    desees conocer.</small
                  >
                </v-stepper-step>
                <v-stepper-content step="8">
                  <v-row v-if="currentStep == 8">
                    <v-col cols="12">
                      <h2 class="title text-center">
                        Campos predefinidos para formulario para registro de
                        asistente
                        <v-tooltip top max-width="350px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" dark v-on="on"
                              >mdi-help-circle</v-icon
                            >
                          </template>
                          <span
                            >La información que sale en los siguientes campos es
                            la que se le solicita a los asistentes al momento de
                            registrarse al evento. (Si lo deseas puedes ocultar
                            el campo de empresa y de teléfono)</span
                          >
                        </v-tooltip>
                      </h2>
                      <v-row justify="center">
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            label="Nombre(s)"
                            required
                            prepend-icon="fas fa-user"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            label="Apellidos"
                            required
                            prepend-icon="fas fa-user"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            label="E-mail"
                            required
                            prepend-icon="fas fa-envelope"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" justify="center">
                          <v-text-field
                            label="Empresa/Institución"
                            prepend-icon="fas fa-industry"
                            :disabled="newEvent.hideCompany"
                          ></v-text-field>
                          <v-row justify="center">
                            <p class="mb-0">
                              Ocultar del formulario de registro
                              <v-tooltip top max-width="350px">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="primary" dark v-on="on"
                                    >mdi-help-circle</v-icon
                                  >
                                </template>
                                <span
                                  >Activa esta opción si no quieres que se le
                                  solicite la empresa o institución a tus
                                  asistentes al momento de registarse en el
                                  evento.</span
                                >
                              </v-tooltip>
                            </p>
                          </v-row>
                          <v-row justify="center">
                            <v-switch
                              v-model="newEvent.hideCompany"
                              color="secondary"
                            ></v-switch>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            label="Teléfono"
                            prepend-icon="fas fa-phone"
                            :disabled="newEvent.hidePhone"
                          ></v-text-field>
                          <v-row justify="center">
                            <p class="mb-0">
                              Ocultar del formulario de registro
                              <v-tooltip top max-width="350px">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="primary" dark v-on="on"
                                    >mdi-help-circle</v-icon
                                  >
                                </template>
                                <span
                                  >Activa esta opción si no quieres que se le
                                  solicite el teléfono a tus asistentes al
                                  momento de registarse en el evento.</span
                                >
                              </v-tooltip>
                            </p>
                          </v-row>
                          <v-row justify="center">
                            <v-switch
                              v-model="newEvent.hidePhone"
                              color="secondary"
                            ></v-switch>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12">
                      <h2 class="title text-center">
                        Si lo deseas puedes agregar campos para conocer
                        información adicional de tus asistentes. Estos campos
                        serán visibles al momento de adquirir boletos para el
                        evento.
                        <v-tooltip top max-width="350px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" dark v-on="on"
                              >mdi-help-circle</v-icon
                            >
                          </template>
                          <span
                            >Además de la información que se muestra arriba,
                            ¿Qué deseas saber sobre tu asistente? Ejemplo:
                            Profesión, edad, género, ciudad, etc.</span
                          >
                        </v-tooltip>
                      </h2>
                      <v-row justify="center">
                        <v-switch
                          color="secondary"
                          v-model="additionalFields"
                          class="ml-3 ml-sm-0"
                          label="Deseo agregar campos adicionales"
                        ></v-switch>
                      </v-row>
                    </v-col>
                    <v-col v-if="additionalFields" cols="12" class="pt-0">
                      <v-row
                        v-for="(field, index) in newEvent.extraFields"
                        :key="index"
                        justify="center"
                      >
                        <v-col cols="12" sm="6" md="4" lg="3">
                          <p class="font-weight-bold">Tipo de campo</p>
                          <v-radio-group
                            v-model="newEvent.extraFields[index].fieldType"
                            :mandatory="false"
                            class="ml-2"
                          >
                            <v-radio
                              color="secondary"
                              label="Campo de texto"
                              value="text"
                            ></v-radio>
                            <v-radio
                              color="secondary"
                              label="Lista de opciones"
                              value="select"
                            ></v-radio>
                          </v-radio-group>
                          <p class="font-weight-bold">Opciones</p>
                          <v-switch
                            class="ml-2"
                            color="secondary"
                            v-model="newEvent.extraFields[index].required"
                            label="¿Obligatorio?"
                          ></v-switch>
                        </v-col>

                        <v-col cols="12" sm="6" md="3" lg="4">
                          <p class="font-weight-bold">Configuración</p>
                          <v-text-field
                            v-model="newEvent.extraFields[index].name"
                            :rules="extraFieldRules"
                            label="Nombre del campo o pregunta"
                          ></v-text-field>
                          <v-text-field
                            v-model="newEvent.extraFields[index].description"
                            label="Descripción"
                          ></v-text-field>
                          <v-combobox
                            v-if="
                              newEvent.extraFields[index].fieldType === 'select'
                            "
                            v-model="newEvent.extraFields[index].options"
                            hide-selected
                            hint="Agrega las opciones de tu campo."
                            label="Opciones del campo"
                            multiple
                            persistent-hint
                            small-chips
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    Presiona
                                    <kbd>enter</kbd> para crear una nueva
                                    keyword.
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-combobox>
                        </v-col>

                        <v-spacer></v-spacer>

                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                          v-if="
                            newEvent.extraFields[index].fieldType === 'text'
                          "
                        >
                          <p class="font-weight-bold">Vista previa</p>
                          <v-text-field
                            v-bind:label="
                              newEvent.extraFields[index].name ||
                              'Nombre del campo o pregunta'
                            "
                            v-bind:hint="
                              newEvent.extraFields[index].description ||
                              'Ej. Descripción del campo'
                            "
                            persistent-hint
                          ></v-text-field>
                        </v-col>

                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                          v-if="
                            newEvent.extraFields[index].fieldType === 'select'
                          "
                        >
                          <p class="font-weight-bold">Vista previa</p>
                          <v-select
                            :items="newEvent.extraFields[index].options"
                            v-bind:label="
                              newEvent.extraFields[index].name ||
                              'Nombre del campo'
                            "
                            v-bind:hint="
                              newEvent.extraFields[index].description ||
                              'Ej. Descripción del campo'
                            "
                            persistent-hint
                          ></v-select>
                        </v-col>

                        <v-col cols="12" class="mt-5 mt-md-0">
                          <v-row justify="center" align="center">
                            <v-btn
                              v-if="newEvent.extraFields.length > 1"
                              color="secondary"
                              @click="
                                newEvent.extraFields.length > 1
                                  ? deleteField(field.name)
                                  : ''
                              "
                              class="mx-2"
                            >
                              <v-icon x-small>fas fa-minus</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="index == newEvent.extraFields.length - 1"
                              color="primary"
                              @click="addField()"
                            >
                              <v-icon x-small>fas fa-plus</v-icon>
                            </v-btn>
                          </v-row>
                        </v-col>

                        <v-col cols="12" class="d-md-none my-5 my-md-0">
                          <v-divider />
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <span v-if="isNewEvent && user.surveyModule">
                    <v-btn
                      color="accent"
                      class="my-3 mx-1"
                      :disabled="!valid"
                      @click="currentStep++"
                      >Continuar
                    </v-btn>
                    <v-btn v-if="!isNewEvent"
                      color="secondary"
                      class="mx-1"
                      @click="validateOrganizerStatus('update')"
                      :disabled="!valid"
                      >Guardar</v-btn
                    >
                    <v-btn text class="mx-1" @click="currentStep--">Regresar</v-btn>
                  </span>
                  <span v-else>
                    <v-row v-if="isNewEvent" class="px-5 pb-5 my-3">
                      <v-btn
                        color="accent"
                        class="mx-1"
                        @click="validateOrganizerStatus('create')"
                        :disabled="
                          !this.valid ||
                          (this.newEvent.hasSurvey &&
                            (!this.newEvent.editorEmail ||
                              !this.newEvent.surveyEndDate))
                        "
                        >Guardar</v-btn
                      >
                      <v-btn text class="mx-1" @click="currentStep--">Regresar</v-btn>
                      <!-- Poner cuando este completado lo del preview del evento
                      <div class="flex-grow-1"></div>
                      <v-btn color="secondary" @click="preview()">Vista previa</v-btn>
                      -->
                    </v-row>
                    <v-row v-else class="px-5 pb-5 my-3">
                      <v-btn
                        color="accent"
                        class="mx-1"
                        @click="validateOrganizerStatus('update')"
                        :disabled="
                          !this.valid ||
                          (this.newEvent.hasSurvey &&
                            (!this.newEvent.editorEmail ||
                              !this.newEvent.surveyEndDate))
                        "
                        >Guardar</v-btn
                      >
                      <v-btn text class="mx-1" @click="currentStep--">Regresar</v-btn>
                    </v-row>
                  </span>
                </v-stepper-content>
                <!-- New surveys step -->
                <v-stepper-step
                  v-if="isNewEvent && user.surveyModule"
                  :editable="
                    isNewEvent || currentStep == 6
                      ? false
                      : valid
                      ? true
                      : false
                  "
                  step="9"
                  color="accent"
                >
                  Encuestas
                  <small
                    >¿Quisieras agregar una encuesta al finalizar tu
                    evento?</small
                  >
                </v-stepper-step>
                <v-stepper-content
                  v-if="isNewEvent && user.surveyModule"
                  step="9"
                >
                  <v-row v-if="currentStep == 9">
                    <v-col cols="12">
                      <h2 class="title text-center">
                        Encuestas
                        <v-tooltip top max-width="350px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="primary" dark v-on="on"
                              >mdi-help-circle</v-icon
                            >
                          </template>
                          <span
                            >El correo electrónico para las encuestas deberá ser
                            una cuenta de gmail.</span
                          >
                        </v-tooltip>
                      </h2>
                      <v-row justify="center">
                        <v-switch
                          class="mr-2"
                          v-model="newEvent.hasSurvey"
                          label="¿Activar encuesta?"
                          color="secondary"
                        ></v-switch>
                      </v-row>
                      <v-row justify="center" v-if="newEvent.hasSurvey">
                        <v-col cols="12" sm="6" xl="3">
                          <v-text-field
                            v-model="newEvent.editorEmail"
                            :rules="emailRules"
                            label="Correo electrónico del editor *"
                            required
                            prepend-icon="fas fa-envelope"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" xl="3">
                          <v-menu
                            v-model="dateMenu3"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="surveyDateFormatted"
                                label="Fecha de termino de la encuesta *"
                                persistent-hint
                                readonly
                                v-on="on"
                                prepend-icon="fas fa-calendar-day"
                                required
                                :rules="surveyEndDateRules"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="newEvent.surveyEndDate"
                              no-title
                              @input="dateMenu3 = false"
                              locale="es"
                              :min="newEvent.endDate"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row v-if="isNewEvent" class="px-5 pb-5 my-3">
                    <v-btn
                      color="accent"
                      @click="validateOrganizerStatus('create')"
                      :disabled="
                        !this.valid ||
                        (this.newEvent.hasSurvey &&
                          (!this.newEvent.editorEmail ||
                            !this.newEvent.surveyEndDate))
                      "
                      >Guardar</v-btn
                    >
                    <v-btn text @click="currentStep--">Regresar</v-btn>
                    <!-- Poner cuando este completado lo del preview del evento
                    <div class="flex-grow-1"></div>
                    <v-btn color="secondary" @click="preview()">Vista previa</v-btn>
                    -->
                  </v-row>
                  <v-row v-else class="px-5 pb-5 my-3">
                    <v-btn
                      color="accent"
                      @click="validateOrganizerStatus('update')"
                      :disabled="
                        !this.valid ||
                        (this.newEvent.hasSurvey &&
                          (!this.newEvent.editorEmail ||
                            !this.newEvent.surveyEndDate))
                      "
                      >Guardar</v-btn
                    >
                    <v-btn text @click="currentStep--">Regresar</v-btn>
                  </v-row>
                </v-stepper-content>
                <!-- / New surveys step -->
              </v-stepper>
            </v-form>
          </v-col>
        </v-row>
        <v-dialog v-model="modalityDialog" max-width="600px" persistent>
          <v-card>
            <v-container>
              <p class="headline font-weight-bold px-3 pt-5 mb-2">
                MODALIDADES DE EVENTOS <i class="fas fa-users primary--text"></i>
              </p>
              <v-row class="mb-3">
                <v-col cols="12" class="px-3 py-0">
                  <v-icon left color="accent">mdi-laptop-chromebook</v-icon><span class="body-1 font-weight-bold">En línea</span>
                </v-col>
                <v-col cols="12" class="px-5 py-0">
                  <p class="text-justify my-0 mx-3">Es un evento virtual transmitido a través de alguna plataforma. WeChamber te permite colocar la liga donde se transmitirá el evento, misma que recibirá el asistente cuando finalice su registro (y pago en su caso).</p>
                </v-col>
              </v-row>
              <v-row class="mb-3">
                <v-col cols="12" class="px-3 py-0">
                  <v-icon left color="accent">mdi-walk</v-icon><span class="body-1 font-weight-bold">Presencial</span>
                  <!--<i class="fas fa-walking fa-lg" color="primary"></i><span class="body-1 font-weight-bold"> Eventos presenciales</span>-->
                </v-col>
                <v-col cols="12" class="px-5 py-0">
                  <p class="text-justify my-0 mx-3">Es un evento que se lleva a cabo en un recinto físico. WeChamber envía un código QR en su correo de confirmación una vez que el asistente finaliza su registro (y pago en su caso).
                  </p>
                </v-col>
              </v-row>
              <v-row class="mb-3">
                <v-col cols="12" class="px-3 py-0">
                  <v-icon left color="accent">mdi-city</v-icon><span class="body-1 font-weight-bold">Híbridos</span>
                </v-col>
                <v-col cols="12" class="px-5 py-0">
                  <p class="text-justify my-0 mx-3">Es un evento que ofrece ambas modalidades: presecial y virtual. WeChamber te permite elegir entre el código QR, la liga de transmisión del evento, o ambas en el mismo correo de confirmación que recibe un asistente al finalizar su registro (y pago en su caso).</p>
                  <p class="text-justify my-0 mx-3">La configuarción de los boletos se realiza en el paso número 4 del formulario.</p>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions class="px-7 pb-4">
              <v-row justify="end">
                <v-btn color="accent" @click="modalityDialog = false">
                  Entendido
                </v-btn>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="bankDataDialog" max-width="600px">
          <v-card>
            <!--<v-row justify="space-between" class="mx-0 px-0 pt-3">
              <v-col cols="12">
                <p class="display-1 font-weight-bold text-left pl-2 ma-0">Agregar datos bancarios</p>
              </v-col>
            </v-row>-->
            <p class="display-1 font-weight-bold px-7 pt-5 mb-2">
              Datos bancarios <i class="fas fa-university amber--text"></i>
            </p>

            <p class="body-2 px-7">
              Esta información será solicitada solamente una ocasión, es aquí
              donde realizaremos las transferencias de tus ventas los días
              martes y viernes.
              <i class="fas fa-exclamation-triangle accent--text"></i>
            </p>
            <v-divider class="pt-3"></v-divider>
            <v-form ref="formBankData" v-model="bankDataValid" lazy-validation>
              <v-row class="ma-0">
                <v-col cols="12" class="px-5">
                  <v-text-field
                    v-model="bankDataOrganization.rfc"
                    label="RFC"
                    :rules="rfcRules"
                    prepend-icon="fas fa-id-card"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-5">
                  <v-text-field
                    v-model="bankDataOrganization.razonSocial"
                    label="Razón social"
                    :rules="razonSocialRules"
                    prepend-icon="fas fa-file-contract"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-5">
                  <v-text-field
                    v-model="bankDataOrganization.bank"
                    label="Banco"
                    :rules="bankRules"
                    required
                    prepend-icon="fas fa-university"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-5">
                  <v-text-field
                    v-model="bankDataOrganization.clabe"
                    label="Cuenta CLABE (Clave Bancaria Estandarizada)"
                    :rules="clabeRules"
                    prepend-icon="fas fa-money-check-alt"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-5">
                  <v-text-field
                    v-model="bankDataOrganization.confirmClabe"
                    label="Confirmación Cuenta CLABE (Clave Bancaria Estandarizada)"
                    :rules="[
                      bankDataOrganization.clabe ==
                        bankDataOrganization.confirmClabe ||
                        'La confirmación de la CLABE no es correcta',
                    ]"
                    prepend-icon="fas fa-money-check-alt"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="px-5">
                  <v-text-field
                    v-model="bankDataOrganization.billEmail"
                    label="Email que recibirá las facturas"
                    :rules="emailRules"
                    required
                    prepend-icon="fas fa-envelope"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions class="px-7 pb-4">
              <v-row justify="space-between">
                <v-btn color="red darken-3" @click="bankDataDialog = false" dark
                  >Cancelar</v-btn
                >
                <v-btn
                  color="secondary"
                  @click="editOrganization(bankDataOrganization)"
                  :disabled="
                    bankDataOrganization.rfc == '' ||
                    bankDataOrganization.razonSocial == '' ||
                    bankDataOrganization.bank == '' ||
                    bankDataOrganization.clabe == '' ||
                    bankDataOrganization.confirmClabe == '' ||
                    bankDataOrganization.billEmail == '' ||
                    !bankDataValid
                  "
                  >Guardar</v-btn
                >
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapMutations, mapState, mapActions } from "vuex";

//Helpers
import { validations } from "@/helpers/validations.js";
import { imageHelper } from "@/helpers/imageProcessing.js";

// Base64
import { Base64 } from "js-base64";

// Fileponp
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

//Tiptap
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";

export default {
  components: {
    FilePond,
    TiptapVuetify,
  },
  data() {
    return {
      originalTicketsQty: 0,
      originalCouponsQty: 0,
      place: null,
      isNewEvent: true,
      blobImg: null,
      files: [null, []],
      valid: false,
      bankDataValid: false,
      currentStep: 1,
      //invalidTicketPrice: false,
      additionalFields: false,
      coupons: false,
      modalityDialog: false,
      bankDataDialog: false,
      bankDataOrganization: {
        rfc: "",
        clabe: "",
        bank: "",
        razonSocial: "",
        billEmail: "",
      },
      extensions: [
        History,
        [Heading, { options: { levels: [1, 2, 3] } }],
        Paragraph,
        Bold,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        Blockquote,
        Link,
        Code,
        HorizontalRule,
      ],

      // DATOS DE LOS SELECT EN INFORMACIÓN DEL EVENTO
      eventCategories: [
        "Capacitación / Curso / Taller",
        "Congreso / Foro / Expo",
        "Diplomados / Maestrías",
      ],
      modalityCategories: [
        {
          item: "Presencial",
          value: "ON_SITE"
        },
        {
          item: "En línea",
          value: "ON_LINE"
        },
        {
          item: "Híbrido",
          value: "HYBRID"
        }
      ],
      categoriesItems: [
        {
          item: "HEADER#Ciencias Físico Matemáticas e Ingenierías",
          value: "Ciencias Físico Matemáticas e Ingenierías",
        },
        { item: "Ingeniería Mecánica", value: "Ingeniería Mecánica" },
        { item: "Ingeniería Eléctrica", value: "Ingeniería Eléctrica" },
        { item: "Química", value: "Química" },
        {
          item: "Medio ambiente y sustentabilidad",
          value: "Medio ambiente y Sustentabilidad",
        },
        { item: "Física y Astronomía", value: "Física y Astronomía" },
        {
          item: "Ciencias de la Computación",
          value: "Ciencias de la Computación",
        },
        {
          item: "Tecnologías de Información",
          value: "Tecnologías de Información",
        },
        {
          item: "HEADER#Ciencias Biológicas y de la Salud",
          value: "Ciencias Biológicas y de la Salud",
        },
        { item: "Medicina", value: "Medicina" },
        { item: "Nutrición", value: "Nutrición" },
        { item: "Fisioterapia", value: "Fisioterapia" },
        { item: "Odontología", value: "Odontología" },
        { item: "Salud Animal", value: "Salud Animal" },
        { item: "Enfermería", value: "Enfermería" },
        { item: "Belleza", value: "Belleza" },
        { item: "HEADER#Ciencias Sociales", value: "Ciencias Sociales" },
        { item: "Economía", value: "Economía" },
        { item: "Educación", value: "Educación" },
        { item: "Gobierno", value: "Gobierno" },
        { item: "Derecho", value: "Derecho" },
        { item: "HEADER#Negocios", value: "Negocios" },
        { item: "Finanzas", value: "Finanzas" },
        { item: "Contabilidad", value: "Contabilidad" },
        { item: "Marketing", value: "Marketing" },
        { item: "Estrategia", value: "Estrategia" },
        { item: "Gestión", value: "Gestión" },
        { item: "Diseño", value: "Diseño" },
        { item: "Construcción", value: "Construcción" },
        { item: "Manufactura", value: "Manufactura" },
        {
          item: "HEADER#Humanidades y de las Artes",
          value: "Humanidades y de las Artes",
        },
        { item: "Música", value: "Música" },
        { item: "Artes Plásticas", value: "Artes Plásticas" },
        { item: "Historia", value: "Historia" },
        { item: "Filosofía", value: "Filosofía" },
        { item: "HEADER#Multidisciplinaria", value: "Multidisciplinaria" },
        { item: "Emprendimiento", value: "Emprendimiento" },
        { item: "Habilidades Blandas", value: "Habilidades Blandas" },
        { item: "Industria 4.0", value: "Industria 4.0" },
        { item: "HEADER#Desarrollo Personal", value: "Desarrollo Personal" },
        { item: "Idiomas", value: "Idiomas" },
        { item: "Oratoria", value: "Oratoria" },
        { item: "Comunicación", value: "Comunicación" },
        { item: "Ortografía", value: "Ortografía" },
        { item: "Trabajo en Equipo", value: "Trabajo en Equipo" },
        { item: "Liderazgo", value: "Liderazgo" },
        { item: "Otro", value: "Otro" },
      ],
      //AMENIDADES
      amenities: [
        "Estacionamiento",
        "Coffee break",
        "Alimentos",
        "Aire acondicionado",
        "Constancia",
        "Cóctel",
        "Valet Parking",
        "Zona Comercial",
      ],
      // OBJETO PARA ALMACENAR UN EVENTO
      newEvent: {
        name: "",
        category: "",
        subcategory: "",
        eventType: "FULL_EVENT",
        registrationWebSite: "",
        details: "",
        modality: "ON_SITE",
        eventImage: "",
        eventFlyer: "",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        freeEvent: false,
        address: {},
        amenities: [],
        socialMedia: {
          facebook: "",
          twitter: "",
          linkedin: "",
          youtube: "",
          instagram: "",
        },
        faqs: [
          {
            question: "",
            answer: "",
          },
        ],
        contactDetails: {
          email: "",
          tel: "",
          webSite: "",
        },
        tags: [],
        installments: false,
        onlineEventUrl: "",
        meetingId: "",
        meetingPass: "",
        private: false,
        productsPerOrder: 5,
        tickets: [
          {
            productType: "TICKET",
            name: "",
            price: 0,
            estatus: "ACTIVE",
            inventory: {
              inventoryType: "FINITE",
              inventoryEstatus: "IN_STOCK",
              quantity: 0,
            },
          },
        ],
        haveCoupons: false,
        coupons: [
          {
            name: "",
            percentOff: 0,
          },
        ],
        sponsors: [],
        hideCompany: false,
        hidePhone: false,
        offerBilling: true,
        totalBreakdown: false,
        quantityOfCourtesies: 0,
        courtesy: [],
        extraFields: [
          {
            description: "",
            fieldType: "text",
            name: "",
            formattedName: "",
            required: false,
          },
        ],
        hasSurvey: false,
        editorEmail: "",
        surveyEndDate: null,
        publishedURL: "",
        editorURL: "",
        spreadsheetId: "",
        message:""
      },
      baseEvent: {
        name: "",
        category: "",
        subcategory: "",
        eventType: "FULL_EVENT",
        registrationWebSite: "",
        details: "",
        modality: "ON_SITE",
        eventImage: "",
        eventFlyer: "",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        freeEvent: false,
        address: {},
        amenities: [],
        socialMedia: {
          facebook: "",
          twitter: "",
          linkedin: "",
          youtube: "",
          instagram: "",
        },
        faqs: [
          {
            question: "",
            answer: "",
          },
        ],
        contactDetails: {
          email: "",
          tel: "",
          webSite: "",
        },
        tags: [],
        installments: false,
        onlineEventUrl: "",
        meetingId: "",
        meetingPass: "",
        private: false,
        productsPerOrder: 5,
        tickets: [
          {
            productType: "TICKET",
            name: "",
            price: 0,
            estatus: "ACTIVE",
            inventory: {
              inventoryType: "FINITE",
              inventoryEstatus: "IN_STOCK",
              quantity: 0,
            },
          },
        ],
        haveCoupons: false,
        coupons: [
          {
            name: "",
            percentOff: 0,
          },
        ],
        sponsors: [],
        hideCompany: false,
        hidePhone: false,
        offerBilling: true,
        totalBreakdown: false,
        quantityOfCourtesies: 0,
        courtesy: [],
        extraFields: [
          {
            description: "",
            fieldType: "text",
            name: "",
            formattedName: "",
            required: false,
          },
        ],
        hasSurvey: false,
        editorEmail: "",
        surveyEndDate: null,
        publishedURL: "",
        editorURL: "",
        spreadsheetId: "",
        message:""
      },
      // VALIDACIONES
      // PASO 1
      eventNameRules: validations.generalValidation({
        required: true,
        minLength: 5,
        maxLength: 55,
        name: "nombre del evento",
      }),
      telRules: validations.phoneValidation(),
      emailRules: validations.emailValidation(),
      webSiteRules: validations.websiteValidation({ required: false }),
      // PASO 2
      categoryRules: validations.requiredFValidation("categoría del evento"),
      subcategoryRules: validations.requiredFValidation(
        "subcategoría del evento"
      ),
      anotherSubcategory: validations.generalValidation({
        required: true,
        minLength: 3,
        maxLength: 80,
        name: "tema del evento",
      }),
      dateMenu1: false,
      startDateRules: validations.requiredFValidation(
        "fecha de inicio del evento"
      ),
      dateMenu2: false,
      endDateRules: validations.requiredFValidation("fecha de fin del evento"),
      timeMenu1: false,
      startTimeRules: validations.requiredFValidation(
        "hora de inicio del evento"
      ),
      timeMenu2: false,
      endTimeRules: validations.requiredFValidation("hora de fin del evento"),
      addressRules: validations.requiredFValidation("dirección del evento"),
      modalityRules: validations.requiredFValidation(
        "modalidad del evento"
      ),
      // PASO 4
      ticketNameRules: validations.requiredValidation("nombre del boleto"),
      ticketTypeRules: validations.requiredValidation("tipo de boleto"),
      ticketPriceRules: validations.numberValidation({
        name: "precio del boleto",
        min: 0,
        max: 1000000,
      }),
      ticketQtyRules: validations.numberFValidation({
        name: "cantidad de boletos",
        min: 0,
        max: 1000000,
      }),
      // PASO 5
      courtesyQtyRules: validations.numberFValidation({
        name: "cantidad de cortesías",
        min: 0,
        max: 5000,
      }),
      couponDiscountRules: validations.numberValidation({
        name: "porcentaje de descuento",
        min: 0,
        max: 100,
      }),
      couponQtyRules: validations.numberValidation({
        name: "cantidad",
        min: 1,
        max: 500,
      }),
      // PASO 6
      exampleTags: ["Ventas", "Control", "Administración"],
      search: null,
      socialMediaRules: validations.websiteValidation({ required: false }),
      //Paso 8
      extraFieldRules: validations.extraFieldValidation(),
      // Paso 9
      dateMenu3: false,
      surveyEndDateRules: validations.requiredFValidation("fecha de termino"),
      //Datos bancarios
      rfcRules: validations.generalValidation({
        required: true,
        minLength: 12,
        maxLength: 13,
        name: "campo",
      }),
      razonSocialRules: validations.generalValidation({
        required: true,
        minLength: 3,
        name: "campo",
      }),
      bankRules: validations.generalValidation({
        required: true,
        name: "campo",
      }),
      clabeRules: validations.generalValidation({
        required: true,
        minLength: 18,
        maxLength: 18,
        name: "campo",
      }),
    };
  },
  async mounted() {
    this.isNewEvent =
      this.$route.fullPath.split("/")[2] === "modificar-evento" ? false : true;
    /* Verificar si se esta editando el evento, si es así realizar ajustes a las variables
      para asignar valores por default si es que el objeto de evento no cuenta con ellos.
      Esto puede causarse porque constantemente se agregan nuevas funciones y en algunas
      ocasiones los eventos que ya estaban creados no cuentan con ciertos campos requeridos
      que son necesarios para poder funcionar con las nuevas funciones agregadas.*/
    if (!this.isNewEvent) {
      // AQUÍ SE HACE LA PETICIÓN AL SERVIDOR PARA TRAER LOS DATOS DEL EVENTO
      await this.fetchEventDetails(this.$route.params.id);
      if (this.currentEvent.address) {
        this.place = this.currentEvent.address.formattedAddress;
      }
      this.originalTicketsQty = this.currentEvent.tickets.length;
      this.originalCouponsQty = this.currentEvent.coupons.length;
      this.newEvent = this.currentEvent;
      // Poner categoría del evento.
      if (
        this.categoriesItems.find(
          (item) => item.value === this.newEvent.subcategory
        ) === undefined
      ) {
        this.newEvent.subcategoryText = this.newEvent.subcategory;
        this.newEvent.subcategory = "Otro";
      }
      /*Asignar que es un evento completo
          (SE AGREGA CAMPO PARA LOS EVENTOS QUE YA ESTABAN CREADOS ANTES AGREGAR FUNCIONALIDAD DE EVENTOS LITE)*/
      if (!this.newEvent.eventType) {
        this.newEvent.eventType = "FULL_EVENT";
        this.newEvent.registrationWebSite = "";
      }
      /*Asignar productos por orden por default (Esta variable establece el límite de boletos que se pueden adquirir por orden en el checkout)
          (SE AGREGA UNA CANTIDAD DE BOLETOS POR ORDEN PARA LOS EVENTOS QUE YA ESTABAN CREADOS ANTES DE DESARROLLAR ESA FUNCIONALIDAD)*/
      if (!this.newEvent.productsPerOrder) {
        this.newEvent.productsPerOrder = 5;
      }
      //Formatear respuesta de preguntas frecuentes
      if (this.newEvent.faqs.length > 0) {
        this.newEvent.faqs.forEach((faq) => {
          faq.answer = Base64.decode(faq.answer);
        });
        for (let i = 0; i < this.newEvent.faqs.length; i++) {
          if (this.newEvent.faqs[i].question == "") {
            this.newEvent.faqs.splice(i, 1);
          }
        }
      }
      /* Si el evento no cuenta con una pregunta frecuente agregarla para que aparezcan
        los campos de una pregunta freguente en el formulario de editar evento.*/
      if (this.newEvent.faqs.length === 0) {
        this.addQuestion();
      }

      //Formatear descripción de evento
      this.newEvent.details = Base64.decode(this.newEvent.details);

      /*Si el evento tiene desactivado el switch de cupones habilitados o se creo antes de que esta función se desarrollara
        y además el primer cupón es un valor vacio y la longitud de su arreglo de cupones es igual a uno, deshabilitar switch de cupones*/
      if (
        this.newEvent.haveCoupons == null &&
        (this.newEvent.coupons[0].name == "" ||
          this.newEvent.coupons.length <= 1)
      ) {
        this.newEvent.haveCoupons = false;
      } else if (
        this.newEvent.haveCoupons == null &&
        (this.newEvent.coupons[0].name != "" ||
          this.newEvent.coupons.length > 1)
      ) {
        this.newEvent.haveCoupons = true;
      }
      //Si el evento se creo después de agregar funcionalidad de ocultar compañia y número télefonico de asistente en el checkout poner valores por default
      if (
        this.newEvent.hideCompany == null &&
        this.newEvent.hidePhone == null
      ) {
        this.newEvent.hideCompany = false;
        this.newEvent.hidePhone = false;
      }
      //Si el evento se agregó después de que se le diera la opción a los organizadores de ofrecer factura en el checkout, poner valor por default.
      if (this.newEvent.offerBilling == null) {
        this.newEvent.offerBilling = true;
      }
      if (this.newEvent.coupons.length > 1) {
        this.coupons = true;
      }
      //Si no se ha configurado ninguna cortesía establecer valores por default
      if (this.newEvent.courtesy == null) {
        this.newEvent.courtesy = [];
      }
      if (this.newEvent.quantityOfCourtesies == null) {
        this.newEvent.quantityOfCourtesies = 0;
      }

      //Revisar condiciones de campos extra y hacer pruebas (No son muy correctas)
      if (
        this.newEvent.extraFields.length > 0 &&
        this.newEvent.extraFields.name != ""
      ) {
        this.additionalFields = true;
      } else {
        this.newEvent.extraFields = [
          {
            description: "",
            fieldType: "text",
            name: "",
            required: false,
          },
        ];
      }
      if (
        this.newEvent.additionalFields &&
        this.newEvent.additionalFields.length > 0
      ) {
        this.additionalFields = true;
      }
    }
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState("event", ["currentEvent"]),
    /**
     * Función para tomar la fecha actual y ponerla en los v-date-picker.
     */
    todayDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
    /**
     * Función para dar formato de la fecha inicial del evento.
     */
    initialDateFormatted() {
      if (this.isNewEvent) return this.formatDate(this.newEvent.startDate);
      else {
        return this.formatDate(this.newEvent.startDate.substring(0, 10));
      }
    },
    /**
     * Función para dar formate de la fecha final del evento.
     */
    finalDateFormatted() {
      if (this.isNewEvent) return this.formatDate(this.newEvent.endDate);
      else {
        return this.formatDate(this.newEvent.endDate.substring(0, 10));
      }
    },
    /**
     * Función para dar formato de la fecha termino de la encuesta.
     */
    surveyDateFormatted() {
      if (this.isNewEvent) return this.formatDate(this.newEvent.surveyEndDate);
      else {
        return this.newEvent.surveyEndDate
          ? this.formatDate(this.newEvent.surveyEndDate.substring(0, 10))
          : null;
      }
    },
  },
  methods: {
    ...mapActions("event", [
      "saveImage",
      "saveImages",
      "createEvent",
      "updateEvent",
      "fetchEventDetails",
    ]),
    ...mapActions("user", [
      "updateBankDataOrganization",
      "checkValidationStatus",
    ]),
    ...mapMutations("notifications", ["show"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    ...mapMutations("event", ["setEvent"]),
    ...mapMutations("user", ["inEventPreview"]),
    handleFilePondInit: function () {},
    /**
     * Función para validar que los campos del formulario hayan sido llenados de la forma correcta.
     */
    validate() {
      if (this.$refs.form.validate()) {
        this.currentStep++;
        this.snackbar = true;
        return true;
      }
      return false;
    },
    /**
     * Función para validar que el campo de la ubicación haya sido llenado si el evento es presencial.
     */
    validateLocation() {
      if (
        this.newEvent.modality === "ON_LINE" ||
        this.newEvent.modality === "HYBRID" ||
        (this.newEvent.address != null && this.newEvent.address.name)
      ) {
        this.currentStep++;
      } else {
        this.show({
          text:
            "¡Si el evento es presencial, es necesario ingresar una dirección!",
          color: "primary",
        });
      }
    },
    /**
     * Función pra validar que se hayan ingresado la información de los boletos de forma correcta.
     */
    validateTickets() {
      if (this.$refs.form.validate()) {
        if (this.newEvent.freeEvent) {
          this.currentStep++;
        }
        this.currentStep++;
        this.snackbar = true;
        return true;
      }
      return false;
      //Validación para evitar que pongan $0 pesos en todos los boletos de un evento que no es gratuito
      /*if (this.$refs.form.validate()) {
        if( this.newEvent.freeEvent ){
          this.currentStep++;
        } else if (this.newEvent.tickets.length==1 && this.newEvent.tickets[0].price == 0) {
           this.invalidTicketPrice = true;
           setTimeout(() => this.invalidTicketPrice = false, 5000);
        } else {
          this.currentStep++;
        }
        this.snackbar = true;
        return true;
      }*/
    },
    /**
     * Función para dar formato de fecha YYYY-MM-DD.
     * @param {String} date Fecha inicial o final del evento.
     */
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    /**
     * Función para agregar un boleto en el formulario (Se añaden otros campos pra ingresar los datos del boleto)
     */
    addTicket() {
      this.newEvent.tickets.push({
        productType: "TICKET",
        name: "",
        price: 0,
        estatus: "ACTIVE",
        inventory: {
          inventoryType: "FINITE",
          inventoryEstatus: "IN_STOCK",
          quantity: 1,
        },
      });
    },
    /**
     * Función para eliminar boletos del formulario
     * (SOLO FUNCIONA CON LOS BOLETOS QUE HAN SIDO AÑADIDOS EN ESE MOMENTO, SI EL EVENTO SE GUARDA CON UNOS
     * BOLETOS Y DESPUÉS SE QUIEREN ELIMINAR NO SE VA A PODER HASTA QUE SE DESARROLLE ESA FUNCIONALIDAD)
     */
    deleteTicket(ticketName) {
      let newTickets = this.newEvent.tickets.filter(
        (ticket) => ticket.name != ticketName
      );
      this.newEvent.tickets =
        newTickets.length > 0
          ? newTickets
          : [
              {
                productType: "TICKET",
                name: "",
                price: 0,
                estatus: "ACTIVE",
                inventory: {
                  inventoryType: "FINITE",
                  inventoryEstatus: "IN_STOCK",
                  quantity: 1,
                },
              },
            ];
    },
    /**
     * Función para eliminar cupones del formulario
     * (SOLO FUNCIONA CON LOS CUPONES QUE HAN SIDO AÑADIDOS EN ESE MOMENTO, SI EL EVENTO SE GUARDA CON UNOS
     * CUPONES Y DESPUÉS SE QUIEREN ELIMINAR NO SE VA A PODER HASTA QUE SE DESARROLLE ESA FUNCIONALIDAD)
     */
    deleteCoupon(couponDescription) {
      let newCoupons = this.newEvent.coupons.filter(
        (coupon) => coupon.name != couponDescription
      );
      this.newEvent.coupons =
        newCoupons.length > 0
          ? newCoupons
          : [{ name: "", percentOff: 0, maxRedemptions: 0 }];
    },
    /**
     * Función para agregar un cupón en el formulario (Se añaden otros campos pra ingresar los datos del cupón)
     */
    addCoupon() {
      this.newEvent.coupons.push({
        name: "",
        percentOff: 0,
      });
    },
    /**
     * Función para habilitar cupones y cortesías en el formulario de evento.
     */
    wantCoupons() {
      if (this.coupons) {
        if (this.newEvent.coupons.length === 0)
          this.newEvent.coupons.push({
            name: "",
            percentOff: 0,
          });
      } else {
        if (
          this.newEvent.coupons.length === 1 &&
          this.newEvent.coupons.name === ""
        )
          this.newEvent.coupons = [];
      }
    },
    /**
     * Función para validar cupones en el formulario
     */
    checkCoupons() {
      if (this.coupons) {
        if (this.validate()) this.currentStep++;
      } else this.currentStep++;
    },
    /**
     * Función para generar cortesías
     */
    generateCortesies() {
      let currentCourtesies = this.newEvent.courtesy.length;
      if (this.newEvent.quantityOfCourtesies > 5000) {
        this.newEvent.quantityOfCourtesies = 5000;
      }
      if (this.newEvent.quantityOfCourtesies > currentCourtesies) {
        //Omitir la letra "e" o "E" porque no se puede visualizar correctamente la cortesía en el Excel
        var carateres =
          "abcdfghijkmnpqrtuvwxyzABCDFGHIJKLMNPQRTUVWXYZ012346789_*$&<>¿?¡!()";
        let courtesy = "";
        for (
          let i = currentCourtesies;
          i < this.newEvent.quantityOfCourtesies;

        ) {
          for (let j = 0; j < 5; j++) {
            courtesy += carateres.charAt(
              Math.floor(Math.random() * carateres.length)
            );
          }
          if (!this.newEvent.courtesy.includes(courtesy)) {
            this.newEvent.courtesy[i] = courtesy;
            i++;
          }
          courtesy = "";
        }
      }
    },
    /**
     * Función para eliminar preguntas frecuentes del evento
     */
    deleteQuestion(question) {
      let newFaq = this.newEvent.faqs.filter(
        (item) => item.question != question
      );
      this.newEvent.faqs =
        newFaq.length > 0 ? newFaq : [{ question: "", answer: "" }];
    },
    /**
     * Función para añadir una pregunta frecuente al evento
     */
    addQuestion() {
      this.newEvent.faqs.push({ question: "", answer: "" });
    },
    /**
     * Función para eliminar un campo extra
     */
    deleteField(fieldName) {
      let newFields = this.newEvent.extraFields.filter(
        (field) => field.name != fieldName
      );
      this.newEvent.extraFields =
        newFields.length > 0
          ? newFields
          : [{ fieldType: "text", required: false, name: "", description: "" }];
    },
    /**
     * Función para agregar un campo extra
     */
    addField() {
      this.newEvent.extraFields.push({
        fieldType: "text",
        required: false,
        name: "",
        formattedName: "",
        description: "",
      });
    },
    /**
     * Función para mostrar una vista previa del evento (AÚN SIN TERMINAR)
     * (CUANDO SE PLANEE DESARROLLAR ESTA FUNCIONALIDA, VERIFICAR QUE SE ENTIENDA EL CÓDIGO,
     * SI NO ES ASÍ, ELIMINARLA Y COMENZARLA DESDE CERO).
     */
    preview() {
      this.setEvent(this.newEvent);
      this.inEventPreview();
      this.$router.push("/dashboard/nuevo-evento/vista-previa");
    },
    /**
     * Función para guardar dirección del evento una vez que ha sido ingresada en el campo de dirección de evento.
     */
    saveAddress(place) {
      let {
        geometry: {
          location: { lat },
        },
        geometry: {
          location: { lng },
        },
        formatted_address,
        name,
      } = place;
      let flag = isNaN(place.address_components.slice(-1)[0].short_name)
        ? true
        : false;
      let components = [];
      if (flag) components = [...place.address_components].slice(-3);
      else components = [...place.address_components].slice(-4);

      this.newEvent.address = {
        lat: lat(),
        lng: lng(),
        formattedAddress: formatted_address,
        name,
        city: components[0].long_name,
        state: components[1].short_name,
      };
      this.place = formatted_address;
    },
    /**
     * Función para dar formato a los boletos de un evento
     */
    formatTickets() {
      this.newEvent.tickets.forEach(ticket => {
        if (this.newEvent.modality == "ON_SITE") {
          ticket.accessType = "ON_SITE";
        } else if (this.newEvent.modality == "ON_LINE") {
          ticket.accessType = "ON_LINE";
        } else {
          ticket.accessType = ticket.accessType && ticket.accessType != ""?ticket.accessType: this.newEvent.modality;
        }
      });
      //console.log(this.newEvent);
    },

    /**
     * Función para dar formato a los campos extra y evitar que den errores por poner caracteres extraños.
     */
    async formatExtraFields() {
      var patron = / /g;
      var patronSigns = /[¿?]/g;
      var newValor = "_";
      var newValorSigns = "";
      var lowerlettera = /á/g,
        lowerlettere = /é/g,
        lowerletteri = /í/g,
        lowerlettero = /ó/g,
        lowerletteru = /ú/g,
        lowerlettern = /ñ/g,
        upperlettera = /Á/g,
        upperlettere = /É/g,
        upperletteri = /Í/g,
        upperlettero = /Ó/g,
        upperletteru = /Ú/g,
        upperlettern = /Ñ/g,
        lowerletteraa = /ã/g,
        upperletteraa = /Ã/g;

      var lowera = "a",
        lowere = "e",
        loweri = "i",
        lowero = "o",
        loweru = "u",
        lowern = "n",
        uppera = "A",
        uppere = "E",
        upperi = "I",
        uppero = "O",
        upperu = "U",
        uppern = "N";
      for (let i = 0; i < this.newEvent.extraFields.length; i++) {
        if (this.newEvent.extraFields[i].name == "") {
          this.newEvent.extraFields.splice(i, 1);
        }
      }
      if (
        this.newEvent.extraFields.length > 0 &&
        this.newEvent.extraFields[this.newEvent.extraFields.length - 1].name ===
          ""
      ) {
        this.newEvent.extraFields.pop();
      }
      let newExtraFields = await Promise.all(
        this.newEvent.extraFields.map(async (extraField) => {
          return await extraField.name
            .replace(patron, newValor)
            .replace(patronSigns, newValorSigns)
            .replace(lowerlettera, lowera)
            .replace(lowerlettere, lowere)
            .replace(lowerletteri, loweri)
            .replace(lowerlettero, lowero)
            .replace(lowerletteru, loweru)
            .replace(lowerlettern, lowern)
            .replace(upperlettera, uppera)
            .replace(upperlettere, uppere)
            .replace(upperletteri, upperi)
            .replace(upperlettero, uppero)
            .replace(upperletteru, upperu)
            .replace(upperlettern, uppern)
            .replace(lowerletteraa, lowera)
            .replace(upperletteraa, uppera);
        })
      );
      newExtraFields.forEach((element, index, array) => {
        this.newEvent.extraFields[index].formattedName = element;
      });
    },
    /**
     * Función para validar el estatus del organizador que quiere crear eventos con costo.
     * (LA FUNCIÓN VERIFICA QUE EL ORGANIZADOR YA HAYA PROPORCIONADO SUS DATOS BANCARIOS).
     */
    async validateOrganizerStatus(method) {
      //let checkValidation = await this.checkValidationStatus();
      //this.user.validationStatus = checkValidation.checkValidationStatus.validationStatus;
      if (
        !this.newEvent.freeEvent &&
        (this.user.validationStatus == undefined ||
          this.user.validationStatus == null ||
          this.user.validationStatus == "NOT_VALIDATED" ||
          this.user.validationStatus == "REJECTED")
      ) {
        this.bankDataDialog = true;
      } else {
        if (method == "create") {
          await this.saveNewEvent();
        } else if (method == "update") {
          await this.updateNewEvent();
        }
      }
    },
    /**
     * Función para editar los datos bancarios de la organización que esta publicando el evento
     */
    async editOrganization(bankData) {
      //let response = await this.checkValidationStatus();
      delete this.bankDataOrganization.confirmClabe;
      await this.updateBankDataOrganization(bankData);
      this.user.validationStatus = "IN_PROCESS";
      this.show({ text: "¡Información bancaria guardada con éxito! 😄" });
      this.bankDataDialog = false;
    },
    /**
     * Función para guardar un nuevo evento
     */
    async saveNewEvent() {
      this.loading();
      await this.generateCortesies();
      // Validar si han seleccionado una subcategoría diferente a las que se muestran en la lista, si es así dar un nuevo formato
      if (
        this.newEvent.subcategory == "Otro" &&
        this.newEvent.subcategoryText != "" &&
        this.newEvent.subcategoryText != undefined
      ) {
        this.newEvent.subcategory = this.newEvent.subcategoryText;
        delete this.newEvent.subcategoryText;
      }

      // Si el evento es en línea quitar la ubicación
      if (this.newEvent.modality === "ON_LINE") {
        this.newEvent.address = null;
        this.place = null;
      }
      // Si se subió una imagen de encabezado del evento guardarlo en el bucket y guardar la URL
      if (this.newEvent.eventImage != "") {
        let eventImage = await imageHelper.saveImage(this.newEvent.eventImage);
        this.newEvent.eventImage = eventImage;
      }
      // Si se subió un flyer de evento guardarlo en el bucket y guardar la URL
      if (this.newEvent.eventFlyer != "") {
        let flyerImage = await imageHelper.saveImage(this.newEvent.eventFlyer);
        this.newEvent.eventFlyer = flyerImage;
      }
      // Si se subieron imagenes de patrocinadores subirlas al bucket
      if (this.newEvent.sponsors.length != 0) {
        let sponsorsImages = await Promise.all(
          this.newEvent.sponsors.map(async (sponsor) => {
            return await imageHelper.saveImage(sponsor);
          })
        );
        this.newEvent.sponsors = sponsorsImages;
      }
      // Codificar en base64 los detalles del evento
      this.newEvent.details = Base64.encode(this.newEvent.details);
      this.formatTickets();
      await this.formatExtraFields();
      await this.createEvent(this.newEvent);
      this.loaded();
      this.show({ text: "¡Evento guardado con éxito! 😄" });
      this.$router.push("/dashboard/eventos");
    },
    async updateNewEvent() {
      this.loading();
      await this.generateCortesies();
      // Validar si han seleccionado una subcategoría diferente a las que se muestran en la lista, si es así dar un nuevo formato
      if (
        this.newEvent.subcategory == "Otro" &&
        this.newEvent.subcategoryText != "" &&
        this.newEvent.subcategoryText != undefined
      ) {
        this.newEvent.subcategory = this.newEvent.subcategoryText;
        //delete this.newEvent.subcategoryText;
      }
      // Si el evento es en línea quitar la ubicación
      if (this.newEvent.modality === "ON_LINE") {
        this.newEvent.address = null;
        this.place = null;
      }
      // Si se subió una imagen de encabezado del evento guardarlo en el bucket y guardar la URL
      if (typeof this.newEvent.eventImage != "string") {
        let eventImage = await imageHelper.saveImage(this.newEvent.eventImage);
        this.newEvent.eventImage = eventImage;
      }
      // Si se subió un flyer de evento guardarlo en el bucket y guardar la URL
      if (
        typeof this.newEvent.eventFlyer != "string" &&
        this.newEvent.eventFlyer != null
      ) {
        let flyerImage = await imageHelper.saveImage(this.newEvent.eventFlyer);
        this.newEvent.eventFlyer = flyerImage;
      }
      // Si se subieron imagenes de patrocinadores subirlas al bucket
      if (typeof this.newEvent.sponsors[0] != "string") {
        let sponsorsImages = await Promise.all(
          this.newEvent.sponsors.map(async (sponsor) => {
            return await imageHelper.saveImage(sponsor);
          })
        );
        this.newEvent.sponsors = sponsorsImages;
      }
      this.newEvent.details = Base64.encode(this.newEvent.details);
      this.formatTickets();
      await this.formatExtraFields();
      await this.updateEvent(this.newEvent);
      this.loaded();
      this.show({ text: "¡Evento actualizado con éxito! 😄" });
      this.$router.push("/dashboard/eventos");
    },
    infiniteTickets(index) {
      if (this.newEvent.tickets[index].inventory.inventoryType == "INFINITE")
        this.newEvent.tickets[index].inventory.quantity = 0;
    },
    /**
     * Función para procesar imágenes de encabezado, flyer y patrocinadores de evento
     * (SE AJUSTAN TAMAÑOS Y SE CAMBIAN LOS NOMBRES)
     */
    async processFile() {
      //Imagen de encabezado de evento
      if (this.$refs.pondHeader.getFiles().length > 0) {
        this.newEvent.eventImage = await imageHelper.resizeImg(
          this.$refs.pondHeader.getFiles()[0].file,
          1920,
          750
        );
      }
      //Imagen de flyer de evento
      if (this.$refs.pondFlyer.getFiles().length > 0) {
        this.newEvent.eventFlyer = await imageHelper.resizeImg(
          this.$refs.pondFlyer.getFiles()[0].file,
          900,
          900
        );
      }
      //Imágenes de patrocinadores
      if (this.$refs.pondSponsors.getFiles().length > 0) {
        this.newEvent.sponsors = await imageHelper.resizeImgs(
          this.$refs.pondSponsors.getFiles()
        );
      }
    },
    modalityChangeActions() {
      if (this.newEvent.modality == "HYBRID") {
        this.modalityDialog = true;
      }
    },
    // Validar que el correo sea del dominio gmail
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(email)) {
        return email.indexOf(
          "@gmail.com",
          email.length - "@gmail.com".length
        ) !== -1
          ? ""
          : "El email debe ser una cuenta de gmail";
      }
    },
  },
  watch: {
    //"newEvent.modality": function (val) {
    //  if (val === "ON_LINE") {
    //    this.newEvent.address = null;
    //    this.place = null;
    //  }
    //},
    "newEvent.freeEvent": function (val) {
      if (val) {
        this.newEvent.installments = false;
        this.newEvent.offerBilling = false;
        this.newEvent.tickets.forEach((element) => {
          element.price = 0;
        });
      }
    },
    $route(to, from) {
      if (to.path === "/dashboard/nuevo-evento") {
        this.isNewEvent = true;
        this.newEvent = JSON.parse(JSON.stringify(this.baseEvent));
        this.currentStep = 1;
      }
    },
  },
};
</script>
<style scoped>
.sponsor-img {
  filter: grayscale(1);
}
</style>